import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { AlertCircle } from 'lucide-react';
import Tooltip from '../ToolTip';

interface IIconStatus {
  classes?: string;
  status?: boolean;
  onclick?: () => void;
  cursorPointer?: boolean;
  title?: string;
  applyBackgroundColor?: boolean;
  isFirstApproved?: boolean;
  toolTipMessage?: string;
}
const IconStatus = ({ classes, status, onclick, cursorPointer = false, title, applyBackgroundColor = false, isFirstApproved, toolTipMessage }: IIconStatus) => {
  return (
    <div className={clsx('', classes)} onClick={onclick}>
      {status ? (
        toolTipMessage ?
        <Tooltip message={toolTipMessage} placement='bottom'>
          <div className={`rounded-full ${applyBackgroundColor ? 'bg-green-100' : ''} flex items-center justify-center gap-1 w-fit px-2 py-1`}>
            <div><CheckCircleIcon className={clsx(
                'h-4 w-4  text-green-600',
                cursorPointer ? 'cursor-pointer':""
              )} /></div>
            <p className='text-green-600 text-[10px] capitalize  whitespace-nowrap'>{title}</p>
          </div>
        </Tooltip> : 
        <div className={`rounded-full ${applyBackgroundColor ? 'bg-green-100' : ''} flex items-center justify-center gap-1 w-fit px-2 py-1`}>
          <div><CheckCircleIcon className=" h-4 w-4  text-green-600 " /></div>
          <p className='text-green-600 text-[10px] capitalize  whitespace-nowrap'>{title}</p>
        </div>
      ) : !status && isFirstApproved ? (
        <div className="" >
          <div className={`rounded-full ${applyBackgroundColor ? 'bg-yellow-100' : ''}  flex items-center justify-center gap-1 w-fit px-2 py-1`}>
            <AlertCircle
              className={clsx(
                ' h-4 w-4 text-yellow-500 cursor-default',
                cursorPointer ? 'cursor-pointer':""
              )}
            />
            <p className='text-yellow-500 text-[10px] capitalize whitespace-nowrap'>{title ? `Not ${title}` : ''}</p>
          </div>
         
        </div>
      ): (
        toolTipMessage ?
        <Tooltip message={toolTipMessage} placement='bottom'>
             <div className={`rounded-full ${applyBackgroundColor ? 'bg-red-100' : ''}  flex items-center justify-center gap-1 w-fit px-2 py-1`}>
            <AlertCircle
              className={clsx(
                ' h-4 w-4 text-red-500 cursor-default',
                cursorPointer ? 'cursor-pointer':""
              )}
            />
            <p className='text-red-500 text-[10px] capitalize  whitespace-nowrap'>{title ? `Not ${title}` : ''}</p>
          </div>
        </Tooltip> : <div className="" >
          <div className={`rounded-full ${applyBackgroundColor ? 'bg-red-100' : ''}  flex items-center justify-center gap-1 w-fit px-2 py-1`}>
            <AlertCircle
              className={clsx(
                ' h-4 w-4 text-red-500 cursor-default',
                cursorPointer ? 'cursor-pointer':""
              )}
            />
            <p className='text-red-500 text-[10px] capitalize  whitespace-nowrap'>{title ? `Not ${title}` : ''}</p>
          </div>
         
        </div>
      )}
    </div>
  );
};

export default IconStatus;
